import { createContext, useContext } from "react"
import { SchemaField } from "./schema"

export type CommonFieldProps = {
  index: number
  field: SchemaField
  append: (value: SchemaField, shouldFocus: boolean) => void
  remove: (index?: number | number[] | undefined) => void
}

/** We use this to provide a unique context to each field being rendered */
export const CommonFieldPropsContext = createContext<
  CommonFieldProps | undefined
>(undefined)

/** Grab the ancestor field props */
export const useCommonFieldProps = () => {
  const context = useContext(CommonFieldPropsContext)
  if (!context) throw Error()
  return context
}
